import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { CpaasCustomerSummary, CpaasCustomer, TnPortalType } from '@nuso/cpaas/types';

export interface TnOrderAccountInfo {
  accountId: number;
  customerId?: number | null;
}

@Injectable()
export abstract class CpaasCustomerService {
  private _customerSummaries$: Observable<CpaasCustomerSummary[]>;

  constructor() {
  }

  public get customerSummaries$(): Observable<CpaasCustomerSummary[]> {
    if (!this._customerSummaries$) {
      this._customerSummaries$ = this.cpaasCustomerSummaries().pipe(
        shareReplay(1)
        // note, this service is open the lifetime of the that app, so we don't need to unsubscribe
      );
    }
    return this._customerSummaries$;
  }

  public abstract cpaasCustomerSummaries(): Observable<CpaasCustomerSummary[]>;
  public abstract cpaasCustomerDetails(customerId: number): Observable<CpaasCustomer | null>;
  public abstract cpaasCustomerDetailsForOrderAccountInfo(orderAccountInfo: TnOrderAccountInfo): Observable<CpaasCustomer | null>;
  public abstract cpaasTnPortalType(): TnPortalType;
  public abstract currentCpaasCustomerSummary(): Observable<CpaasCustomerSummary | null>;
}
